export let timeline = (_d={}) => {
    return `
<div class="controlbar-progress-duration">
    <span class="controlbar-progress-bar"></span>
</div>`;
};